import { Component, EventEmitter, Input, OnDestroy, OnInit, Output,  } from '@angular/core';
import { environment } from '@env';
import { NbDialogRef } from '@nebular/theme';
import { SortByOrderPipe } from '@shared/pipes/sort-by-order.pipe';
import { WindowService } from '@shared/services/window.service';
import { Subscription } from 'rxjs';
import { IShareAvailableUser } from '../../interfaces/share-available-user.interface';
import { IShareUser } from '../../interfaces/share-user.interface';

@Component({
  selector: 'app-share-with-user-modal',
  templateUrl: './share-with-user-modal.component.html',
  styleUrls: ['./share-with-user-modal.component.scss'],
  providers: [SortByOrderPipe]
})
export class ShareWithUserModal implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() loading: boolean = false;
  @Input() assignedUsers: IShareUser[] = [];
  @Input() availableUsers: IShareAvailableUser[] = [];

  private subscriptions: Subscription = new Subscription();

  protected selectedUserEmail: string | null = null;
  protected baseAvatarUrl = environment.inCloud.baseUrl;

  @Output() onShare = new EventEmitter<string>(); 
  @Output() onDeleteUser = new EventEmitter<IShareUser>(); 
  
  constructor(
    protected dialogRef: NbDialogRef<ShareWithUserModal>,
    private readonly windowService: WindowService,
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected trackByFn<T extends { id: string }>(index: number, item: T) {
    return item.id;
  }

  protected openOrganizationTab(): void {
    alert('TODO');
  }

  public removeAvailableUserFromList(email: string): void {
    const index = this.availableUsers.findIndex(u => u.email === email);
    
    this.availableUsers.splice(index, 1);
    this.selectedUserEmail = null;
  }

  public removeUserFromView(user: IShareUser): void {
    const index = this.assignedUsers.findIndex(u => u.id === user.id);

    this.assignedUsers.splice(index, 1);

    this.availableUsers.push({
      isActive: true,
      text: `${user.name} (${user.email})`,
      email: user.email,
    });
  }
}
